/**
 * WHICH SIDEBAR NAV GROUPS THE PERSON HAS FOLDED AWAY.
 *
 * Kept per-browser, like the backlog filters (src/filters.ts) — a person's view
 * of their own sidebar is theirs, not shared, and it is a convenience, not state
 * anything else reads. So localStorage, wrapped so private browsing (where the
 * accessor throws) just means the groups do not persist rather than a crash.
 *
 * ⚠️ THE GROUP HOLDING THE CURRENT VIEW IS NEVER HIDDEN. That rule lives at the
 * one place that renders the nav (App.tsx), not here — this only records the
 * preference. Reading it back, an unknown value widens (shows the group) rather
 * than narrowing, the same safe direction the filters take.
 */
const KEY = 'flightdeck-nav-collapsed';

export function readCollapsedGroups(): Set<string> {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return new Set(Array.isArray(raw) ? raw.filter((x): x is string => typeof x === 'string') : []);
  } catch {
    return new Set();
  }
}

export function writeCollapsedGroups(groups: Set<string>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...groups]));
  } catch {
    /* private browsing — the fold state just will not persist */
  }
}
